<div class="container">
  <ifm-dashboard-vendor-offer-widget *ngFor="let offer of offers"
                                [offer]="offer">
  </ifm-dashboard-vendor-offer-widget>
</div>
